import { useMemo } from "react";

import { FormProps } from "../../framework/react/FormProvider";
import { useFormDialog } from "../components/FormDialog";
import { FormItem } from "../../framework/core/form-item.model";

export const useStopWorkingForCustomerDialog = (customerName: string | null, onConfirm: FormProps<FormItem>["onSubmit"]) => {

    const form: FormItem = useMemo(() => {
        return {
            type: "page",
            title: "Fjern kunde",
            item: {
                type: "group",
                render: "all at once",
                items: [
                    {
                        type: "info",
                        render: "default",
                        text: `
                            ${customerName ?? "Kunden"} fjernes fra oversigten “Tidligere kunder”.
                        `,
                    },
                    {
                        type: "notice",
                        render: "warning",
                        html: `<strong>OBS:</strong> Får du behov for at tilføje ${customerName ?? "kunden"} igen, er du nødt til at bede om hjælp.`,
                    },
                ],
            },
        };
    }, [customerName]);

    return useFormDialog(form, onConfirm);
};
